import { HOST_API_BASE_URL } from 'services/connections.service';

const config = {
  productListAPIEndPoint: `${HOST_API_BASE_URL}/host/product-listing-search`
};

export default config;
